import { FC } from "react";

import { Check, Warning } from "@livechat/design-system-icons";
import { Icon, Info, Tag, Tooltip } from "@livechat/design-system-react-components";

interface IProps {
  forwarded: boolean;
}

export const StatusBadge: FC<IProps> = ({ forwarded }) => {
  if (forwarded) {
    return (
      <Tooltip
        triggerRenderer={() => (
          <Tag
            kind="success"
            size="small"
            leftNode={<Icon source={Check} size="small" />}
            data-testid="forwarding-set-up-badge"
          >
            Forwarding set up
          </Tag>
        )}
        kind="invert"
        placement="top"
      >
        <Info text="The forwarding is set up properly and a copy of the emails reaches HelpDesk." theme="invert" />
      </Tooltip>
    );
  }
  return (
    <Tooltip
      triggerRenderer={() => (
        <Tag
          kind="warning"
          size="small"
          leftNode={<Icon source={Warning} size="small" />}
          data-testid="forwarding-not-set-up-badge"
        >
          Forwarding not set up
        </Tag>
      )}
      kind="invert"
      placement="top"
    >
      <Info text="The forwarding isn't set up yet, and a copy of the emails doesn't reach HelpDesk." theme="invert" />
    </Tooltip>
  );
};
